import { useState, useEffect, useCallback } from "react";
import getList from "../lib/api/getList";

const useUnitConversion = (props) => {
    const { unitGroupId } = props || {};
    const [unitPurposeList, setUnitPurposeList] = useState([]);
    const [unitGroupDetailList, setUnitGroupDetailList] = useState([]);
    const [unitGroupDetailListByUnitGroupId, setUnitGroupDetailListByUnitGroupId] = useState([]);

    const fetchUnitPurposeAll = useCallback(async () => {
        try {
            const response = await getList("VwMapMaterialPurposeUnit");
            const { data } = response;

            return (
                data?.map((item) => ({
                    materialCode: item.materialCode,
                    materialCodeVer: item.materialCodeVer,
                    purposeName: item.purposeName,
                    unitSymbol: item.unitSymbol,
                    unitId: item.unitId,
                    unitPurposeId: item.unitPurposeId,
                })) || []
            );
        } catch (err) {
            console.error("Failed to fetch unit purpose list:", err);
            throw err;
        }
    }, []);

    const fetchUnitGroupDetailAll = useCallback(async () => {
        try {
            const response = await getList("MaterialUnitGroupDetail/materialCode/materialCodeVer/unitList/all");
            const { data } = response;

            return (
                data?.map((item) => ({
                    unitId: item.unitId,
                    unitSymbol: item.unitSymbol,
                    conversionFactor: item.conversionFactor,
                    baseUnitId: item.baseUnitId,
                    materialCode: item.materialCode,
                    materialCodeVer: item.materialCodeVer,
                })) || []
            );
        } catch (err) {
            console.error("Failed to fetch unit group detail list:", err);
            throw err;
        }
    }, []);

    const fetchUnitGroupDetailByUnitGroupId = useCallback(async (unitGroupId) => {
        try {
            const response = await getList(`VwMaterialUnitGroupDetail/${unitGroupId}`);
            const { data } = response;

            return (
                data?.map((item) => ({
                    unitId: item.unitId,
                    unitSymbol: item.unitSymbol,
                    conversionFactor: item.unitConversionFactor,
                })) || []
            );
        } catch (err) {
            console.error("Failed to fetch unit group detail list by unit group id:", err);
            throw err;
        }
    }, []);

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            const [unitGroupDetailList, unitPurposeList, unitGroupDetailListByUnitGroupId] = await Promise.all([
                fetchUnitGroupDetailAll(),
                fetchUnitPurposeAll(),
                fetchUnitGroupDetailByUnitGroupId(unitGroupId),
            ]);

            if (mounted) {
                setUnitGroupDetailList(unitGroupDetailList);
                setUnitPurposeList(unitPurposeList);
                setUnitGroupDetailListByUnitGroupId(unitGroupDetailListByUnitGroupId);
            }
        };

        fetchData();

        return () => {
            mounted = false;
        };
    }, [fetchUnitGroupDetailAll, fetchUnitPurposeAll, fetchUnitGroupDetailByUnitGroupId, unitGroupId]);

    return {
        unitPurposeList,
        unitGroupDetailList,
        unitGroupDetailListByUnitGroupId,
    };
};

export default useUnitConversion;
